import NavBar from "./components/NavBar";
import MainSlider from "./components/MainSlider";
import WhatsIcon from "./components/WhatsAppIcon";
import Footer from "./components/Footer";
import Tabs from "./components/Tabs";

function Home() {
  return (
    <div className="main__page-container">
      <NavBar />
      <MainSlider />
      <Tabs />
      <WhatsIcon />
      <Footer />
    </div>
  );
}

export default Home;
